import styled from 'styled-components';
import is from 'styled-is';

import cardWidths from './cardWidths';

const Card = styled.div`
  ${cardWidths}
  margin-bottom: ${(props) => props.theme.base.gridSizes.XS};
  border-radius: 4px;
  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2);
  overflow: hidden;

  ${is('lightCard')`
    opacity: .6;
  `}

  ${is('clickable')`
    cursor: pointer;
  `}
`;

export default Card;
